export * from './NftDetailsProperties';
